module.exports = __webpack_public_path__ + "static/hero-logo-32e2d92d2b5c72dad10f94641197f9ef.png";